<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">
  <div class="col-6 align-self-center">
    <h3>Account Detail</h3>
  </div>
  <div class="col-6 text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-10 text-center">
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Account Source:</dt>
          <dd class="col-sm-8">
            <select class="form-control" placeholder="Select" [(ngModel)]="account.source">
              <option *ngFor="let source of sourceList | keyvalue" [value]="source.value">{{source.key}}</option>
            </select>
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Account Name:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="account.name" class="form-control" placeholder="Account Name">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Account Label:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="account.label" class="form-control" placeholder="Account Label">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Partner ID:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="account.partnerId" class="form-control" placeholder="Partner ID">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">API Key:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="account.apiKey" class="form-control" placeholder="API Key">
          </dd>
        </dl>
      </div>
    </div>
  </div>
</div>
